import { api } from './api';

export interface RosterStudent {
  studentId: number;
  displayName: string;
  enrolledAt: string;
  completedTopics: number;
  totalTopics: number;
}

export interface StudentTopicActivity {
  nodeId: number;
  topicTitle: string;
  contentAccessed: boolean;
  topicStatus: string;
  quizAttemptCount: number;
  latestQuizScore: number | null;
  assessmentStatus: string | null;
}

export interface RemovedStudent {
  studentId: number;
  displayName: string;
  enrolledAt: string;
  removedAt: string;
}

export const getRoster = async (courseId: number): Promise<RosterStudent[]> => {
  const res = await api.get<{ data: RosterStudent[] }>(`/api/tutor/courses/${courseId}/roster`);
  return res.data.data;
};

export const getStudentActivity = async (courseId: number, studentId: number): Promise<StudentTopicActivity[]> => {
  const res = await api.get<{ data: StudentTopicActivity[] }>(`/api/tutor/courses/${courseId}/roster/${studentId}`);
  return res.data.data;
};

export const removeStudent = async (courseId: number, studentId: number): Promise<void> => {
  await api.delete(`/api/tutor/courses/${courseId}/roster/${studentId}`);
};

export const reinstateStudent = async (courseId: number, studentId: number): Promise<void> => {
  await api.post(`/api/tutor/courses/${courseId}/roster/${studentId}/reinstate`);
};

export const getRemovedStudents = async (courseId: number): Promise<RemovedStudent[]> => {
  const res = await api.get<{ data: RemovedStudent[] }>(`/api/tutor/courses/${courseId}/roster/removed`);
  return res.data.data;
};
